<template>
<div>
<!--   <div v-for="(suite, key) in sortedSuites">
    {{ key }}
  </div> -->
    <schedule
      v-for="suite in sortedSuites"
      :key="suite.id"
      :id="id"
      :suiteId="suite.id"
      :showTitle="true"
      :isReport="true"
    >
    </schedule>
</div>
</template>

<script>
import { db } from '@/services/firebase'
import Schedule from '@/components/attendees/Schedule'

export default {
  props: {
    id: { type: String },
  },
  data() {
    return {
      str: 'hello word',
      suites: []
    }
  },
  computed: {
    sortedSuites() {
      const newArray = [...this.suites]
      return newArray.sort((a, b) => {
        if (a.company.name.toLowerCase() === b.company.name.toLowerCase()) {
          return a.name.toLowerCase() > b.name.toLowerCase();
        } else {
          return a.company.name.toLowerCase() > b.company.name.toLowerCase();
        }
      })
    }
  },
  firestore() {
    return {
      suites: db.collection('meetings').doc(this.id).collection('suites')
    }
  },
  components: {
    Schedule
  }
}
</script>


// WEBPACK FOOTER //
// src/components/meeting/PrintableSchedules.vue